module.exports = __webpack_public_path__ + "img/R6.3c245808.png";